module.exports = __webpack_public_path__ + "img/slide2.92f15a52.png";